import { canonicalRouteSpecs } from './routeCatalog';

export type RouteAccess = 'authenticated' | 'member-ai-v2' | 'member' | 'member-automation' | 'member-non-dawson';

export type AppRouterContext = Readonly<{
  auth: Readonly<{
    isAuthenticated: boolean;
    isDawsonsWarehouseUser: boolean;
    isMember: boolean;
    loading: boolean;
    roles: readonly string[];
  }>;
  featureFlags: Readonly<{ automationSettings: boolean; aiV2?: boolean }>;
  isE2E: boolean;
}>;

export type AuthStatus = 'authenticated' | 'loading' | 'signed-out';
export type FrameKey = 'authenticated' | 'single-audience';

export const PENDING_APP_ROUTER_CONTEXT: AppRouterContext = {
  auth: { isAuthenticated: false, isDawsonsWarehouseUser: false, isMember: false, loading: true, roles: [] },
  featureFlags: { automationSettings: false },
  isE2E: false,
};

export function getAuthStatus(context: AppRouterContext): AuthStatus {
  if (context.auth.isAuthenticated) return 'authenticated';
  if (context.auth.loading) return 'loading';
  return 'signed-out';
}

export function isRouteDeclared(context: AppRouterContext, access: RouteAccess): boolean {
  if (access === 'authenticated') return true;
  if (access === 'member-ai-v2') return context.auth.isMember && context.featureFlags.aiV2 === true;
  if (access === 'member') return context.auth.isMember;
  if (access === 'member-automation') {
    return context.auth.isMember && context.featureFlags.automationSettings;
  }
  return context.auth.isMember && !context.auth.isDawsonsWarehouseUser;
}

export function getFrameKey(access: RouteAccess): FrameKey {
  return access === 'authenticated' ? 'authenticated' : 'single-audience';
}

function beforeFirst(value: string, delimiter: string): string {
  const index = value.indexOf(delimiter);
  return index === -1 ? value : value.slice(0, index);
}

export function resolveSignedOutLoginHref(
  context: AppRouterContext,
  access: RouteAccess | undefined,
  currentHref: string
): string {
  const hrefWithoutHash = beforeFirst(currentHref, '#');
  const redirectTo =
    access !== undefined && isRouteDeclared(context, access) ? hrefWithoutHash : beforeFirst(hrefWithoutHash, '?');
  return `${canonicalRouteSpecs.login.path}?${new URLSearchParams({ redirectTo }).toString()}`;
}
